import { InboxOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Modal, Row, Upload } from 'antd'
import React, { useState } from 'react'
import { getFile } from '../../../utils/uploadFile'

const style = { marginButton: '3em' }

const LiabilityDeterminationTicketModal = ({
  liabilityDeterminationModalVisible,
  setLiabilityDeterminationModalVisible,
  ticketId,
  accessToken,
  setSelectedTicket,
  selectedTicket
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState([])

  
  const handleDocumentChange = (info) => {
    let _data = []
    _data = info?.fileList.map((file) => {
      return {
        originFileObj: file?.originFileObj,
      }
    })
    setSelectedTicket({
        ...selectedTicket,
        documents: _data
    })
  }

  const getDocuments = async (files) => {
    let documents = []
    let res = []

    for (const id in files) {
      if (Object.hasOwnProperty.call(files, id)) {
        const file = files[id]
        res = await getFile(file.originFileObj, setLoading, accessToken)
        if (res) {
          documents.push(res)
        }
      }
    }
    return documents
  }

  const dummyRequest = async ({ file, onSuccess }) => {    
    setTimeout(() => {
       onSuccess("ok");
    }, 0);
  }

  const handleSubmit = async (values) => {
    const res = await getDocuments(files)
    setLoading(true)
    // const data = {
    //   documents: res,
    // }
    setFiles([])
    setSelectedTicket({
      ...selectedTicket,
      documents: res
    })

    // const data = {
    //   reason: values.reason,
    // }

    // try {
    //   const res = await resolveTicket(ticketId, data, accessToken)
    //   if (res.data.data.length > 0) {
    //     setSelectedTicket(res.data.data[0])
    //     notification.success({
    //       message: 'Ticket Resolved',
    //       description: `You have resolved Ticket ID ${res.data.data[0].complaintNo}..`,
    //     })
    //   }
    //   setLoading(false)
    // } catch (error) {
    //   setLoading(false)

    //   return notification.error({
    //     message: 'Error',
    //     description: `${error}`,
    //   })
    // }

    setLiabilityDeterminationModalVisible(false)
  }

  return (
    <Modal
      visible={liabilityDeterminationModalVisible}
      title={<b>Liability Determination</b>}
      onCancel={() => setLiabilityDeterminationModalVisible(false)}
      footer={[
        <Button
          type="primary"
          key="reset"
          ghost="true"
          className="custom__ghost__button"
          onClick={() => {
            setLiabilityDeterminationModalVisible(false)
            form.resetFields()
          }}
        >
          Cancel
        </Button>,
        <Button
          type="primary"
          key="submit"
          htmlType="submit"
          className="custom__primary__button"
          onClick={form.submit}
          loading={loading}
        >
          Submit
        </Button>,
      ]}
    >
      <Row>
        <Col style={style} span={24}>
            <Form.Item label="Upload Documents" name="documents">
                <Upload.Dragger
                    multiple={true}
                    onChange={handleDocumentChange}
                    style={{ padding: '2em' }}
                    customRequest={dummyRequest}
                    >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p
                        className="ant-upload-text"
                        style={{ fontSize: '13px' }}
                    >
                        Click or drag file to this area to upload
                    </p>
                </Upload.Dragger>
            </Form.Item>
        </Col>
        <Col span={24}>
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item label="Comments" name="reason">
              <Input.TextArea placeholder="Give comments..." rows={5} />
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Modal>
  )
}

export default LiabilityDeterminationTicketModal
